import { useQuery } from '@tanstack/react-query';

import { getFileUrl } from '../utils/axios';
import { queryKeys } from './queryKeys';

const PROFILE_PICTURE_TIMEOUT_MS = 2500;

export function useProfilePicture(enabled: boolean) {
  const { data, error, isLoading, refetch } = useQuery<string | null>({
    queryKey: queryKeys.getProfilePicture(),
    queryFn: ({ signal }) =>
      getFileUrl({
        signal,
        timeout: PROFILE_PICTURE_TIMEOUT_MS,
        url: '/users/current/profile-picture',
      }),
    enabled,
    retry: false,
    // Retain the image for this app session; uploads invalidate it explicitly.
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    profilePictureUrl: data ?? undefined,
    error,
    isLoading,
    refetch,
  };
}
